import React, { useEffect } from "react";
import "./CenterAlert.css";

const CenterAlert = ({ isOpen, type = "success", title, message, onClose }) => {
  
  // Auto-dismiss the toast after 3 seconds
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={`toast-alert-container ${type}`}>
      <div className="toast-icon">
        <i className={type === "success" ? "fa-solid fa-circle-check" : "fa-solid fa-circle-exclamation"}></i>
      </div>
      
      <div className="toast-content">
        <h4>{title}</h4>
        <p>{message}</p>
      </div>

      <button className="toast-close-btn" onClick={onClose} aria-label="Close">
        <i className="fa-solid fa-xmark"></i>
      </button>
    </div>
  );
};

export default CenterAlert;